<template>
  <div class="competencies__component">
    <div class="container__fw">
      <div class="full has__sub competencies">
        <div class="bg">
          <div class="slanted"></div>
        </div>
        <div class="content">
          <h2 class="heading">Expertise</h2>
          <ul class="skills__set">
            <li>Agility</li>
            <li>Service Delivery</li>
            <li>Software Development</li>
            <li>Project Management</li>
            <li>Research & Development</li>
            <li>Full-Stack Engineering</li>
          </ul>
          <div class="more__skills">
            <button class="view__more__button" @click="visible = !visible">
              View more
            </button>

            <transition name="component-fade" mode="out-in">
              <div class="other__skills__wrapper" v-if="visible">
                <ul class="skills__set others">
                  <li>Project Life-cycle Management</li>
                  <li>Risk Mitigation</li>
                  <li>Mentoring</li>
                  <li>DevOps Culture</li>
                  <li>Auditing</li>
                  <li>Scorecard Management</li>
                  <li>Quality Assurance</li>
                  <li>Open Source</li>
                  <li>Scalability</li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.competencies {
  display: grid;
  grid-template-columns:
    [full-start] minmax(5vw, 1fr) [container-start] minmax(300px, 1100px)
    [container-end] minmax(5vw, 1fr) [full-end];
  grid-auto-rows: 100px 1fr 30px;

  .bg {
    grid-column: full;
    grid-row: 1 / 4;
    width: 100%;

    z-index: 1;
    position: relative;

    .slanted {
      background: var(--color-grey);
      clip-path: polygon(100% 1%, 0% 100%, 100% 100%);
      width: 100%;
      height: 100%;
    }
  }

  .content {
    margin: 50px auto 0;
    max-width: 1;
    grid-column: container;
    grid-row: 2 / 3;
    background: var(--color-expertise-bg);
    border-radius: var(--border-radius);
    width: 100%;
    z-index: 1;
    padding: calc(var(--gutter) * 2) calc(var(--gutter) * 5)
      calc(var(--gutter) * 1);
    box-shadow: 0px 0px 35px rgba(0, 0, 0, 0.2);

    .heading {
      font-size: 50px;
      font-weight: 600;
      margin: 0;
      margin-bottom: calc(var(--gutter) * 2);
      letter-spacing: -1px;
      color: var(--color-text-dark);
    }

    .skills__set {
      display: grid;
      grid-gap: var(--gutter);
      list-style-type: none;
      list-style-image: none;
      grid-template-columns: 1fr 1fr 1fr;
      margin: 0;
      padding: 0;
      margin-bottom: var(--gutter);

      li {
        margin: 0;
        padding: calc(var(--gutter) / 1.6) var(--gutter);
        color: white;
        background: var(--color-blue);
        border-radius: 50px;
        font-size: 16px;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &.others {
        grid-template-columns: 1fr 1fr 1fr 1fr;

        li {
          background: none;
          color: var(--color-text-dark);
          padding: 0;
          font-size: 14px;
        }
      }
    }

    .more__skills {
      .view__more__button {
        padding: calc(var(--gutter) / 2) var(--gutter);
        border: 0;
        background: none;
        color: var(--color-text-light);
        height: 40px;
        border-radius: 20px;
        transition: all 0.3s ease-in-out;

        &:hover {
          cursor: pointer;
          background: var(--color-text-light);
          color: white;
        }
      }

      .other__skills__wrapper {
        margin: var(--gutter);
      }
    }
  }
}

@media (max-width: 1024px) {
  .competencies {
    .content {
      padding: calc(var(--gutter) * 2) calc(var(--gutter) * 3);
      margin-top: 0;

      .skills__set {
        grid-template-columns: 1fr 1fr;

        &.others {
          grid-template-columns: 1fr 1fr;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .competencies {
    .content {
      padding: calc(var(--gutter) * 2) calc(var(--gutter) * 2);
      margin-top: 0;

      .skills__set {
        grid-template-columns: 1fr 1fr;

        li {
          font-size: 15px;
        }

        &.others {
          grid-template-columns: 1fr 1fr;
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .competencies {
    .content {
      padding: calc(var(--gutter) * 2) calc(var(--gutter) * 2);
      margin-top: 0;

      .heading {
        font-size: 40px;
      }

      .skills__set {
        grid-template-columns: 1fr;

        li {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
